import { Button, Column, Grid } from "@carbon/react";

import {
  Card,
  Chart,
  ChartWithSummary,
  CurrencyDisplay,
  DatePicker,
  Filter,
  QuickTableFilterTabs,
  SummaryTable,
} from "../../components";
import { QuickSummaryColumData } from "./QuickSummaryColumnData";
import { SetupAccordion } from "./SetupAccordion";
import {
  fullWidthChartData,
  total,
  chartTitle,
  smallChartsData,
  summaryTableData,
} from "../../test-data";
import { formatAsCurrency, numberWithCommas } from "../../utils";

import settingsIcon from "../../assets/icons/settings-icon.svg";

export const View = ({ monthlyOrYearlyQueryStringTabs }) => {
  return (
    <Grid fullWidth>
      <Column sm={4} md={8} lg={16} className="accordion-container">
        <SetupAccordion />
      </Column>

      <Column sm={4} md={6} lg={16}>
        <h3>
          <strong>Today</strong>
        </h3>
      </Column>

      <Column sm={4} md={8} lg={12}>
        <Grid>
          <Column sm={4} md={8} lg={12}>
            <QuickSummaryColumData />
          </Column>

          <Column sm={4} md={8} lg={12}>
            <Card>
              <Grid>
                <ChartWithSummary
                  chartXAxisStartLabel={"12.00AM"}
                  chartXAxisStopLabel={"Now:11:37AM"}
                  chartTitle={chartTitle}
                  chartData={fullWidthChartData}
                  total={total}
                  hasSummaryData
                  summaryRightTopTitle={"Available Balance"}
                  summaryRightTopUrl={"#"}
                  summaryRightTopText={"Overall Transactions"}
                  summaryRightTopValue={"₦400,000"}
                  summaryRightBottomTitle={"Payouts"}
                  summaryRightBottomUrl={"#"}
                  summaryRightBottomText={"Deposited June 29"}
                  summaryRightBottomValue={"₦200,000"}
                />
              </Grid>
            </Card>
          </Column>
        </Grid>
      </Column>

      <Column sm={4} md={8} lg={4}>
        <Card>
          <SummaryTable Title="Last 30 days" data={summaryTableData} />
        </Card>
      </Column>

      <Column sm={4} md={6} lg={16} className="reports">
        <div className="section-title">
          <h4>
            <strong>Reports Overview</strong>
          </h4>
        </div>

        <div className="flex-container justify-content--sb">
          {/* Tab Filters */}
          <div className="flex-box flex-container justify-content--sb">
            <div className="no-flex">
              <Filter />
            </div>
            <DatePicker startDate="Jun 24" endDate="Jun 31" />

            <div className="flex-box" />

            <div className="button-tabs">
              <QuickTableFilterTabs
                queryStringTabNavLinks={monthlyOrYearlyQueryStringTabs}
                tabListType={"contained"}
              />
            </div>

            <Button
              size="md"
              kind="tertiary"
              className="switchapp-themed edit-chart--button"
            >
              <img src={settingsIcon} alt="settings icon" />
              Edit chart
            </Button>
          </div>
        </div>
      </Column>

      <Column sm={4} md={8} lg={16}>
        <Card>
          <Grid className="chart-row--first cht1" fullWidth>
            <ChartWithSummary
              {...smallChartsData[0]}
              chartXAxisStartLabel={"Feb 2022"}
              chartXAxisStopLabel={"June 2022"}
              total={
                <CurrencyDisplay
                  currencySymbol={`${smallChartsData[0].prefix || ""}`}
                  amount={formatAsCurrency(smallChartsData[0].total)}
                />
              }
            />

            <ChartWithSummary
              chartXAxisStartLabel={"Feb 2022"}
              chartXAxisStopLabel={"June 2022"}
              {...smallChartsData[1]}
              total={`${smallChartsData[1].prefix || ""}${numberWithCommas(
                smallChartsData[1].total
              )}${smallChartsData[1].suffix || ""}`}
            />

            <ChartWithSummary
              chartXAxisStartLabel={"Feb 2022"}
              chartXAxisStopLabel={"June 2022"}
              {...smallChartsData[2]}
              total={`${smallChartsData[2].prefix || ""}${numberWithCommas(
                smallChartsData[2].total
              )}${smallChartsData[2].suffix || ""}`}
            />

            <ChartWithSummary
              chartXAxisStartLabel={"Feb 2022"}
              chartXAxisStopLabel={"June 2022"}
              {...smallChartsData[3]}
              total={`${smallChartsData[3].prefix || ""}${numberWithCommas(
                smallChartsData[3].total
              )}${smallChartsData[3].suffix || ""}`}
            />
          </Grid>

          <Grid fullWidth>
            <ChartWithSummary
              chartXAxisStartLabel={"Feb 2022"}
              chartXAxisStopLabel={"June 2022"}
              {...smallChartsData[4]}
              total={`${smallChartsData[4].prefix || ""}${numberWithCommas(
                smallChartsData[4].total
              )}${smallChartsData[4].suffix || ""}`}
            />

            <ChartWithSummary
              chartXAxisStartLabel={"Feb 2022"}
              chartXAxisStopLabel={"June 2022"}
              {...smallChartsData[5]}
              total={`${smallChartsData[5].prefix || ""}${numberWithCommas(
                smallChartsData[5].total
              )}${smallChartsData[5].suffix || ""}`}
            />

            <ChartWithSummary
              chartXAxisStartLabel={"Feb 2022"}
              chartXAxisStopLabel={"June 2022"}
              {...smallChartsData[6]}
              total={`${smallChartsData[6].prefix || ""}${numberWithCommas(
                smallChartsData[6].total
              )}${smallChartsData[6].suffix || ""}`}
            />

            <ChartWithSummary
              chartXAxisStartLabel={"Feb 2022"}
              chartXAxisStopLabel={"June 2022"}
              {...smallChartsData[7]}
              total={`${smallChartsData[7].prefix || ""}${numberWithCommas(
                smallChartsData[7].total
              )}${smallChartsData[7].suffix || ""}`}
            />
          </Grid>
        </Card>
      </Column>
    </Grid>
  );
};
